import CategoryCard from './CategoryCard'

export default CategoryCard
